import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './../auth/auth.guard';

import { CatalogoComponent } from './catalogo.component';
import { HomeComponent } from './pages/home/home.component';
import { ListComponent } from './pages/list/list.component';
import { PromocaoComponent } from './pages/promocao/promocao.component';
import { OutletComponent } from './pages/outlet/outlet.component';
import { FavoritosComponent } from './pages/favoritos/favoritos.component';
import { DetailComponent } from './pages/detail/detail.component';

const routes: Routes = [
  {
    path: 'catalogo',
    component: CatalogoComponent,
    children: [
      { path: '', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'artigos/:search', component: ListComponent, canActivate: [AuthGuard] },
      { path: 'promocao/:id', component: PromocaoComponent, canActivate: [AuthGuard] },
      { path: 'promocao/:id/:search', component: PromocaoComponent, canActivate: [AuthGuard] },
      { path: 'outlet', component: OutletComponent, canActivate: [AuthGuard] },
      { path: 'outlet/:id', component: OutletComponent, canActivate: [AuthGuard] },
      { path: 'outlet/:id/:search', component: OutletComponent, canActivate: [AuthGuard] },
      { path: 'favoritos', component: FavoritosComponent, canActivate: [AuthGuard] },
      { path: 'detail/:id', component: DetailComponent, canActivate: [AuthGuard] },
      { path: '', redirectTo: '/catalogo', pathMatch: 'full' },
      { path: '**', redirectTo: '/catalogo' }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CatalogoRoutingModule { }
